import { render } from "./MagLogo.vue?vue&type=template&id=4ad0768e&scoped=true"
import script from "./MagLogo.vue?vue&type=script&lang=js"
export * from "./MagLogo.vue?vue&type=script&lang=js"

import "./MagLogo.vue?vue&type=style&index=0&id=4ad0768e&scoped=true&lang=css"

import exportComponent from "C:\\code\\kascenskaforvt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad0768e"]])

export default __exports__